import { CheckCircle2, XCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { api, frDate } from './api';
import { assignWithChecks } from './AssignPanel';
import { validateSplit } from './SplitDialog';

export function PreparationBanner({ d, h, run, confirm, busy, canValidate }) {
    const p = d.preparation;
    if (!p) return null;
    const validate = async () => {
        if (p.cible === 'validate') return h.create();
        if (!(await confirm(`Valider la préparation de ${p.par} ?\n\n${p.resume}`, { title: 'Validation définitive', confirmLabel: 'Valider' }))) return;
        const calls = { affecter: () => assignWithChecks(d.id, p.body, confirm), 'link-existing': () => api.linkExisting(d.id, p.body), 'attach-document': () => api.attachDocument(d.id, p.body), repartition: () => validateSplit(d.id, p.body, confirm) };
        run(calls[p.cible], 'Préparation validée');
    };
    const reject = async () => {
        if (!(await confirm('Refuser cette préparation ? La facture reste en attente, rien n\'est enregistré.', { confirmLabel: 'Refuser', danger: true }))) return;
        run(() => api.rejectPreparation(d.id), 'Préparation refusée');
    };
    return (
        <div className="rounded-xl border border-sky-200 bg-sky-50 p-3 space-y-2" data-testid="invoice-preparation">
            <p className="text-[12px] text-sky-900"><b>Préparée par {p.par}</b> le {frDate(p.le)} — en attente de validation par un gérant</p>
            <p className="text-[12px] text-sky-800 whitespace-pre-line" data-testid="invoice-preparation-resume">{p.resume}</p>
            {canValidate && (
                <div className="flex gap-2">
                    <Button size="sm" onClick={validate} disabled={busy} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="invoice-preparation-validate"><CheckCircle2 className="w-4 h-4 mr-1" />Valider</Button>
                    <Button size="sm" variant="outline" onClick={reject} disabled={busy} data-testid="invoice-preparation-reject"><XCircle className="w-4 h-4 mr-1" />Refuser</Button>
                </div>
            )}
        </div>
    );
}
